import { OverlayRef } from '@angular/cdk/overlay';
import { Observable, Subject } from 'rxjs';
import { IBbitCampsite, IBbitCampsiteBookingPeriodWithCampsites } from '../camping.interfaces';

export interface ICampingBookingOverlayData {
  campsite?: IBbitCampsite;
  period?: IBbitCampsiteBookingPeriodWithCampsites;
}

export class CampingBookingOverlayRef {
  private _data!: ICampingBookingOverlayData;
  private _onClose = new Subject<boolean>();

  public constructor(private _overlayRef: OverlayRef) {}

  public close(reload = false): void {
    this._overlayRef.dispose();
    this._onClose.next(reload);
    this._onClose.complete();
  }

  public setData(data: ICampingBookingOverlayData): void {
    this._data = data;
  }

  public getData(): ICampingBookingOverlayData {
    return this._data;
  }

  public observeClose(): Observable<boolean> {
    return this._onClose.asObservable();
  }
}
